/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 4.20 PM
 */

import axios from 'axios';
import cookie from './cookie';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_ROOT,
    headers: {
        Accept: 'application/json',
    },
});

// Request interceptor
api.interceptors.request.use(async (request) => {
    const token = cookie.get('tpanel');
    if (token) {
        request.headers.common.Authorization = `Bearer ${token}`;
    }

    return request;
});

api.interceptors.response.use(
    (response) => response.data,
    (onValue) => {
        if (onValue === 'undefined') {
            return;
        }

        const { response } = onValue;
        const { status, data } = response;
        if (status === 401) {
            cookie.remove('t');
            cookie.remove('rt');
            // window.location.assign('/login');
        }

        // if (status === 500) {
        // Alert.error(`${status} - ${data.message}`);
        // }

        return Promise.resolve({ errors: data });
    },
);

export default api;
